export const MOUNTAINS_DATA = {
  religion: {
    title: "Mountain of Religion",
    desc: "Shaping global spirituality, worship, and faith communities.",
    image: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?q=80&w=800",
    color: "#EA580C",
  },
  family: {
    title: "Mountain of Family",
    desc: "Restoring and strengthening the foundational unit of society.",
    image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=800",
    color: "#F97316",
  },
  education: {
    title: "Mountain of Education",
    desc: "Shaping minds, curriculum, and the future of learning.",
    image: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?q=80&w=800",
    color: "#EF4444",
  },
  government: {
    title: "Mountain of Government",
    desc: "Establishing righteous and effective governance at every level.",
    image: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?q=80&w=800",
    color: "#3B82F6",
  },
  media: {
    title: "Mountain of Media",
    desc: "Controlling the narrative — broadcasting truth at scale.",
    image: "https://images.unsplash.com/photo-1495020689067-958852a7765e?q=80&w=800",
    color: "#8B5CF6",
  },
  arts: {
    title: "Mountain of Arts",
    desc: "Redeeming culture through music, film, fashion, and creativity.",
    image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=800",
    color: "#EC4899",
  },
  business: {
    title: "Mountain of Business",
    desc: "Creating wealth and prosperity aligned with Kingdom values.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800",
    color: "#10B981",
  },
};

export const TERRITORIES = [
  { id: "TERR-001", name: "Nigeria - South West", region: "Lagos, Ogun, Oyo, Osun, Ondo, Ekiti" },
  { id: "TERR-002", name: "Nigeria - South South", region: "Rivers, Delta, Bayelsa, Cross River, Akwa Ibom" },
  { id: "TERR-003", name: "Nigeria - South East", region: "Anambra, Enugu, Ebonyi, Imo, Abia" },
  { id: "TERR-004", name: "Nigeria - North Central", region: "Abuja, Niger, Kaduna, Plateau" },
  { id: "TERR-005", name: "Nigeria - North West", region: "Kano, Katsina, Kaduna, Kebbi, Sokoto" },
  { id: "TERR-006", name: "Nigeria - North East", region: "Borno, Yobe, Adamawa, Taraba, Gombe" },
  { id: "TERR-007", name: "Africa - Diaspora", region: "Global - North America, Europe, Asia" },
];
